import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/default-ai-agent-fab.vue
var o = {
	name: "DtIconDefaultAiAgentFab",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--default-ai-agent-fab"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Default Ai Agent Fab",
		viewBox: "0 0 12 12",
		xmlns: "http://www.w3.org/2000/svg"
	}, [...t[0] || (t[0] = [r("path", {
		"fill-rule": "evenodd",
		"clip-rule": "evenodd",
		d: "M6 2a4 4 0 0 0 0 8h4.5a.5.5 0 1 1 0 1H6a5 5 0 1 1 4.167-2.235.5.5 0 1 1-.833-.553A4 4 0 0 0 6 2Zm2.3 5.1a.5.5 0 0 1 .1.7A2.996 2.996 0 0 1 6 9a2.996 2.996 0 0 1-2.4-1.2.5.5 0 1 1 .8-.6c.366.487.946.8 1.6.8.654 0 1.235-.313 1.6-.8a.5.5 0 0 1 .7-.1Z",
		fill: "currentColor"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=default-ai-agent-fab.js.map